import React from 'react';
import { Svg, Path } from "react-native-svg-web";


export const HappyFaceIcon = ({
  className,
  color = '#333333',
  size = '24px',
  style }) => /*#__PURE__*/

React.createElement(Svg, {

  className: className,
  style: style,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(Path, {
  d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M14 9.5C14 10.3284 14.6716 11 15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M7 9.5C7 10.3284 7.67157 11 8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M15.7148 15.4364C16.4774 14.6283 16.8512 13.7183 16.9702 13.2425L15.0299 12.7575C14.9821 12.9483 14.7559 13.5384 14.2602 14.0636C13.7914 14.5604 13.0857 15 12 15C10.9143 15 10.2086 14.5604 9.73978 14.0636C9.24407 13.5384 9.01787 12.9483 8.97015 12.7575L7.02987 13.2425C7.14882 13.7183 7.52262 14.6283 8.28525 15.4364C9.07476 16.2729 10.2857 17 12 17C13.7143 17 14.9253 16.2729 15.7148 15.4364Z",
  fill: color }));